<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn
                    color="indigo"
                    class="white--text"
                    :to="{ name: 'users/create' }"
                >
                    <v-icon left>mdi-account-plus</v-icon>
                    {{ $t('users-index.buttons.create') }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table">
                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="editItem(item)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="deleteItem(item)"
                                    :disabled="
                                        item.id ==
                                            $store.getters['auth/user'].id
                                    "
                                >
                                    <v-icon color="red" v-on="on"
                                        >mdi-close</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.delete') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>

        <confirm
            ref="confirm"
            :confirmText="$t('dialogs-confirm.buttons.remove')"
        ></confirm>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Confirm from '@/components/dialogs/Confirm'
import User from '@/models/User'

export default {
    components: {
        'sarala-table': SaralaTable,
        confirm: Confirm,
    },

    computed: {
        model() {
            return new User()
        },
    },

    methods: {
        editItem(item) {
            this.$router.push({
                name: 'users/edit',
                params: { id: item.id },
            })
        },

        async deleteItem(item) {
            let confirm = await this.$refs.confirm.open(
                this.$t('users-index.messages.delete'),
                this.$t('users-index.messages.delete-confirmation', {
                    name: item.name,
                }),
            )

            if (!confirm) return

            let clone = item.clone()

            let res = await clone.delete()

            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('users-index.bus.delete-error', {
                        name: item.name,
                    }),
                )
                return
            }

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('users-index.bus.delete-success', { name: item.name }),
            )
        },
    },
}
</script>
